import React, { Component } from "react";
import "./bondhome.css";
import { t } from "i18next";
import BondProfile from "../../../assets/svgs/bond_home.svg";
import {
  BreadCrumb,
  Button,
  TitleView,
  SideModel,
} from "../../components";
import * as Bl from "../../../businesslogic";
import { INVESTMENT_CATEGORY } from "../../constants";
import { getFinancialMarketPath, getUserId} from "../../common";

const newInvestment = {
  investmentcategory: INVESTMENT_CATEGORY.BONDS,
  currentvalue: 0,
  annualcontribution: 0,
  maturityyear: 0,
  maturityvalue: 0,
  expectedror: 0,
  userid: "",
  contributiongrowthrate: 0,
  investementtype: "YEAR",
  investmentdetails: [
    {
      isfliberadvise: false
    },
  ],
  investmentdescription: "",
  fvatretirement: 0,
  maturityage: 0,
  userage:0,
  isincludefinancialplan: false
};

class BondHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newInvestmentData: new Bl.Investment({...newInvestment, userid: getUserId()}),
      investmentData: [],
    };
  }

  onSelectItem(path) {
    this.props.navigate(path);
  }

  onPressSaveButton() {
    this.props.navigate("/bonddetailpage", {
      state: {
        investmentData: this.state.newInvestmentData,
        isEditView: false,
      },
    });
  }

 

  renderNavView() {
    const items = getFinancialMarketPath("Bonds");
    const location = this.props.location;
    return (
      <BreadCrumb
        items={items}
        isLastPath={true}
        currentPath={location.pathname}
        onClickBackIcon={this.onSelectItem.bind(this)}
        onClickItem={this.onSelectItem.bind(this)}
      />
    );
  }

  renderTitleView() {
    const title = t("networthAssetsFM3");
    return <TitleView title={title} />;
  }

  renderProfileView() {
    return (
      <div className="bond_profile_view">
        <img
          src={BondProfile}
          alt={t("networthAssetsFM3")}
          className="bond_icon"
        />
        <div className="bond_save">
          <Button
            buttonName={t("bondButton")}
            onPressButton={this.onPressSaveButton.bind(this)}
          />
        </div>
      </div>
    );
  }

  renderDrawerContent() {
    const headerTitle = t("financialPlan");
    const step = 1;
    return <SideModel step={step} headerTitle={headerTitle}></SideModel>;
  }
  renderContentView() {
    return (
      <div className="bond_content_view">
        {this.renderTitleView()}
        {this.renderProfileView()}
      </div>
    );
  }

  render() {
    return (
      <div className="bond_container">
        {this.renderNavView()}
        {this.renderContentView()}
        {/* {this.renderDrawerContent()} */}
      </div>
    );
  }
}

export default BondHome;
